// @flow
import React, { Component } from 'react';
import Button from '@atlaskit/button';
import { AtlasKitThemeProvider } from '@atlaskit/theme';
import axios from 'axios';
import Config from '../config';
import ModalDialog, { ModalFooter, ModalTransition } from '@atlaskit/modal-dialog';
import { sendAnalytics } from '../../analytics';

import Spinner from '@atlaskit/spinner';

import {
  hideApiLoader,
  setRoomPassProtect,
  setUserIsLogin,
  setUserLoginData,
  setWaitingScreen,
  setWaitingScreenStatus,
  showApiLoader
} from "../redux/tool-webjam/actions"
import { connect } from '../../base/redux';
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2, FEATURE_CUSTOM_REDUX_V3 } from '../constant';
import { checkUserSession, getIpValidation, getOrganizationList, getOrganizationListAuth, getRoomDetail, getSiteConfig, getUserLocation, reminderEmailToRoomOwner, userLogin, userSignup, verifySocialToken } from '../welcome-dashboard/Request.d';
import { messages } from '../welcome-dashboard/messages';
import Toast from 'react-simple-toasts';

import { connect as conferenceConnect } from "../../base/connection";
import { ValidateEmail, _ValidateIPaddress, ValidateUsername, ValidatePassword, apiVersion, setLJsonStorage, getLJsonStorage } from "../welcome-dashboard/Utils";
//import { setAudioMuted, setCameraFacingMode, setVideoMuted } from './actions';
const { socket_endpoint } = Config;
import { socketEmit, socketOn } from "../../../../socket";

var url = window.location.href.replace(/\/$/, '');
// var room = url.substr(url.lastIndexOf('/') + 1);

// var room = CURRENT_ROOM_NAME;
var room = getWebRoomName(CURRENT_ROOM_NAME);

// if (room) {
//   room = room.substring(1);
// }

console.log("CURRENT_ROOM_NAME login index ", CURRENT_ROOM_NAME)

var isFirstTime = true;

import { maybeShowSuboptimalExperienceNotification } from '../../conference/components/functions';
// import { calculateTimeDiff, isMobileBrowserC, _startConference } from '../Utils';
import { calculateTimeDiff, dispatch, getBaseConfig, getStore, InvitedUserConfirmFlag, isIpad, isMobileBrowserC, isSocialMobileApp, _startConference, sleep, isGhostUser } from '../Utils';
import { getLocalParticipant } from '../../base/participants';
import cross from '../img/cross.png';
import { Constant, CURRENT_ROOM_LOCATION, CURRENT_ROOM_NAME } from '../../webjam/constant';
import { getJwtUrl } from '../authorize/CommonFunction';
import { setPaidRoomDetail, setShowConnectPopup, setToolModal } from '../redux/tool-webjam-v2/actions';
import { setAlwaysShowPreJoining, setShowInvitedUserRegistrationModal } from '../redux/tool-webjam-v3/actions'; // new changes
import { updateSettings } from '../../base/settings';
import { StartRecordingDialog } from '../../recording/components/Recording/web';
import { openDialog } from '../../base/dialog';
import { getSocialToken } from '../custom/components/CommonComponents';
import jwt_decode from "jwt-decode";
import { isNumeric } from 'jquery';
import { canUserJoinMeeting, isChinaRegion } from '../custom/components/HelperComponent';
import { INFO_CODE } from '../custom/components/deviceInfoMessage';
// new changes
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { Stack } from '@mui/material';
import { InviteRegisterModal } from '../custom/components/InviteRegisterModal';
import { JammingCapabilityModal } from '../custom/components/JammingCapabilityModal';
import { PrejoinScreenUserRoute } from '../custom/components/PrejoinScreenUserRoute';
import Dialog from '../../base/ui/components/web/Dialog';
import { ct, dynamicMessageLocale, getWebRoomName } from '../constant-Utils';
import { setPrejoinPageVisibility } from '../../prejoin/actions.web';


const FULL_SCREEN_EVENTS = [
  'webkitfullscreenchange',
  'mozfullscreenchange',
  'fullscreenchange'
];

declare var APP: Object;


class Footer extends Component {

  render() {
    const { onClose, showKeyline, text, onSubmit, isLoading, roomPassProtectModal, className, isWaiting } = this.props;

    // the focus should be on the subtle button, but it isn't
    return (
      <ModalFooter showKeyline={showKeyline} className={className}>
        {isWaiting ?
          <Button appearance="subtle" className="cancel-button" onClick={
            (e) => {
              e.preventDefault();
              if (isSocialMobileApp()) {
                window.parent.location.href = getBaseConfig("appReferrerUrl");
              } else {
                // social url change code
                let socialAllowed = getBaseConfig("socialAllowed");
                if (socialAllowed == true) {
                  setTimeout(() => {
                    window.parent.location.href = getBaseConfig("socialReferrerUrl") + "/OuIVuX07";
                  }, 2000);
                } else {
                  window.location.href = "/"
                }
              }
            }
          }>
            {ct("Translate.buttonTitle.cancelSmall")}
          </Button>
          :
          <>
            {!isLoading ?
              <Button className="submit-button login-btn-pass join-meeting-pass" onClick={onSubmit}>
                {text}
              </Button> :
              // <button className="submit-button join-meeting-pass" ><Spinner size="small" /> </button>
              <button className="submit-button join-meeting-pass pull-right pt-3" ><Spinner size="medium" /> </button>
            }
            {
              !roomPassProtectModal ?
                <Button appearance="subtle" className="cancel-button" onClick={onClose}>
                  {ct("Translate.buttonTitle.cancelSmall")}
                </Button>
                //  : ''}
                :
                <Button appearance="subtle" className="cancel-button" onClick={
                  (e) => {
                    e.preventDefault();
                    if (isSocialMobileApp()) {
                      window.parent.location.href = getBaseConfig("appReferrerUrl");
                    } else {
                      // social url change code
                      let socialAllowed = getBaseConfig("socialAllowed");
                      if (socialAllowed == true) {
                        setTimeout(() => {
                          window.parent.location.href = getBaseConfig("socialReferrerUrl") + "/OuIVuX07";
                        }, 2000);
                      } else {
                        window.location.href = "/"
                      }
                    }
                  }
                }>
                  {ct("Translate.buttonTitle.cancelSmall")}
                </Button>
            }


          </>
        }
      </ModalFooter>
    );
  }
}

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: {
        username: '',
        password: ''
      },
      register: {
        username: '',
        password: '',
        email: ''
      },
      forgotpass: {
        email: ''
      },
      isLoading: false,
      isSignUpOpen: false,
      isForgetPass: false,
      systemIp: '',
      localIp: '',
      // browserSession: window.detectDevice(),
      browserSession: "chrome",
      isMaskEye: true,
      openSignIn: false,
      openSignUp: false,
      openForgotPass: false,
      openWaiting: true,
      notSignIn: false,
      isWaitingInterval : false
    };
  }

  async componentDidMount() {
    let willAuthorize = getBaseConfig("willAuthorize");
    let socialAllowed = getBaseConfig("socialAllowed");
    const { dispatch, userLoginData, _iAmRecorder } = this.props;

    if (isGhostUser()) {
      if (CURRENT_ROOM_NAME.length > 1) {
        await sleep(2000);
        dispatch(setAlwaysShowPreJoining(false))
        _startConference("ghost_user_connect");
        return false;
      }
    }

    if (window.location.search.indexOf("resbheri") != -1) {
      setTimeout(() => {
        _startConference("join dev testing");
      }, 5000)
      return false;
    }

    dispatch(getSiteConfig())

    if (isGhostUser()) {
      if (CURRENT_ROOM_NAME.length > 1) {
        await sleep(2000);
        dispatch(setAlwaysShowPreJoining(false))
        _startConference("ghost_user_connect");
        return false;
      }
    }

    if (willAuthorize == true && CURRENT_ROOM_NAME?.length > 1) {
      getJwtUrl()
    } else if (socialAllowed == true) {
      if (!isGhostUser()) {
        let socialRoom = CURRENT_ROOM_NAME;
        if (socialRoom.length > 1 && !isNumeric(socialRoom)) {
          let socialTokenVerified = await getSocialToken();
          await isChinaRegion();
          if (!socialTokenVerified) {
            window.parent.location.href = Constant.App.socialUrl
            return false;
          }
        }
      }
    } else {
      dispatch(getOrganizationList())
    }
    let getLocalAuth = localStorage.getItem("auth");
    if (localStorage.getItem("auth")) {
      getLocalAuth = JSON.parse(getLocalAuth);
      if (getLocalAuth.hasOwnProperty("token")) {
        if (getLocalAuth?.is_jamming == true) {
          return false;
        }
        if (getLocalAuth.hasOwnProperty("is_invited") && getLocalAuth?.is_invited == true && getLocalAuth.is_invited == true && getLocalAuth.room_name == CURRENT_ROOM_NAME) {
          return false;
        }
        await isChinaRegion();
        await checkUserSession(getLocalAuth.token, "login index")
          .then((data) => {
            if (data?.status == 1) {
              // if (data.data.hasOwnProperty("stripe_account_id")) {// TODO: will discuss with johny sir later
              // if (data.data.stripe_account_id == true) {

              sessionStorage.setItem("u_detail", JSON.stringify({
                ...userLoginData.user,
                connectVerified: data.data.connectVerifiedStatus,
                stripe_account_id: data.data.stripe_account_id,
                type: "checksession"
              }))


              let userDetail = {};
              let userData = localStorage.getItem("auth");
              let user_id = "";
              let user_email = "";
              let user_name = "";
              let rta_social_id = "";
              if (userData) {
                userData = JSON.parse(userData);
                user_id = userData?.id || "";
                user_email = userData?.email || "";
                user_name = userData?.username || "";
                rta_social_id = userData?.rtaSocialUserId || "";
              }
              if (userLoginData.user.hasOwnProperty("id")) {
                userDetail = userLoginData;
              } else {
                userDetail = {
                  ...userLoginData,
                  user: {
                    id: user_id,
                    email: user_email,
                    username: user_name,
                    rtaSocialUserId: rta_social_id,
                  }
                }
              }

              let store_v1 = getStore(FEATURE_CUSTOM_REDUX);
              // if(store_v1.userLoginData?.user){
              //   roomData.user = {
              //     ...roomData.user,
              //     ...store_v1.userLoginData?.user
              //   }
              // }

              dispatch(setUserLoginData({
                ...userDetail,
                user: {
                  ...userDetail.user,
                  connectVerified: data.data.connectVerifiedStatus,
                  stripe_account_id: data.data.stripe_account_id,
                  type: "checksession",
                  ...store_v1.userLoginData?.user
                }
              }, 5))
              // }
              // }
              // if (data.data.hasOwnProperty("connectVerifiedStatus")) {
              //   setLJsonStorage("auth", { connectVerified: data.data.connectVerifiedStatus })
              // }
              dispatch(setUserIsLogin(true));
            }
          });
      }
    }

    let _this = this;
    _this.getRoomStatus(1);


    if (CURRENT_ROOM_NAME) {
      setTimeout(function () {
        let hash = window.location.hash;
        if (hash.indexOf("config.iAmRecorder") != -1) {
          let willGhostConnect = false;

          let room = CURRENT_ROOM_NAME;
          // if (room) {
          //   room = room.substring(1);
          // }
          let time = Math.round(new Date().getTime() / 1000);
          let prevConf = sessionStorage.getItem("conference_ghost_" + room);

          if (prevConf) {
            if (!isNaN(prevConf)) {
              if (time - prevConf > 10) {
                willGhostConnect = true;
              }
            } else {
              willGhostConnect = true;
            }
          } else {
            willGhostConnect = true;
          }

          if (willGhostConnect) {
            sessionStorage.setItem("conference_ghost_" + room, time);
            window.location.reload();
          }
        }
      }, 12000)
    }
  }

  async getRoomStatus(from = '') {
    console.log("get room status ", from)

    if (getWebRoomName(CURRENT_ROOM_NAME).length < 2) {
      console.log("get room status is empty ", from)

      return true;
    }

    const { isUserLogin, _iAmRecorder } = this.props;

    // if (from == 1 && getBaseConfig("socialAllowed")) {
    //   if (window.location.hash.indexOf("config.iAmRecorder") == -1 && window.location.hash.indexOf("AUDIO_GHOST") == -1 &&  !_iAmRecorder) {
    //     return true;
    //   }
    // }

    let willAuthorize = getBaseConfig("willAuthorize");
    // console.log('GHOST USER =>', isUserLogin, window.location.hash.indexOf("config.iAmRecorder") == -1, window.location.hash.indexOf("AUDIO_GHOST") == -1, _iAmRecorder, willAuthorize)
    if (!isUserLogin && (isGhostUser()) && willAuthorize == false) {
      console.log("check base ment 1")
      // if (isMobileBrowserC() || isIpad()) {
      //   return false
      // } else {
      let _this = this;
      setTimeout(function () {
        const { isUserLogin } = _this.props
        if (isUserLogin) {
          console.log("check base ment 2")

          _this.setState({ openSignIn: false, notSignIn: false })
        } else {
          if (getBaseConfig("guestUser") == false) {
            console.log("check base ment 3")

            _this.setState({ openSignIn: true, notSignIn: true })
          }
        }
      }, 2000)
      // }
    }

    if ((getBaseConfig("guestUser") == true || (getBaseConfig("guestUser") == false && localStorage.getItem("musicModeUserNotify")) || isUserLogin) || (isGhostUser())) {
      this.setState({ openSignIn: false })
      // Currently if room is claimed it showing login pop up with deepling button
      // if (isMobileBrowserC()) { return false }
      let rep = 0;
      if (_ValidateIPaddress(room)) {
        if (room.includes(":")) {
          room = room.replace(":", "_")
        }
        let isValid = await getIpValidation(room);
        if (isValid.status == 2 && rep == 0) {
          rep++;
          let newRoomName = isValid.response.data.newRoomName
          if (newRoomName.includes(":")) {
            newRoomName = newRoomName.replace(":", "_")
          }
          if (CURRENT_ROOM_NAME != newRoomName) {
            if (getBaseConfig('socialAllowed')) {
              if (isSocialMobileApp()) {
                window.parent.location.href = getBaseConfig("appReferrerUrl") + "/" + newRoomName;
              } else {
                window.parent.location.href = getBaseConfig('socialReferrerUrl') + '/' + newRoomName;
              }
            } else {
              window.location.href = window.location.origin + '/' + newRoomName;
            }
          }
          // return false;
        }
      }
      let isLoginAvail = getBaseConfig("willAuthorize")

      if (isLoginAvail && isLoginAvail == true) {
      } else {
        // const { browserSession, systemIp, localIp } = this.state;
        // const { isUserLogin, setCurrentUser, _iAmRecorder } = this.props;

        const { isUserLogin, setCurrentUser, isWaiting, invitedUserConfirm } = this.props;
        const { browserSession, systemIp, localIp } = this.state;
        localStorage.removeItem("askAgain");

        // if (isWaiting) {
        //   this.setState({ openWaiting: false })
        //   dispatch(showApiLoader())
        // }

        let requestPay = {
          method: 'get',
          url: `${socket_endpoint + (getBaseConfig("apiVersion") || apiVersion)}/user_session/chrome/1.1.1.1/1.1.1.1/${getWebRoomName(CURRENT_ROOM_NAME)}`,
          // url: `${socket_endpoint + apiVersion}/user_session/${browserSession}/${localIp}/${systemIp}/${room}`,
        }

        let getLocalAuth = localStorage.getItem("auth");
        if (getLocalAuth) {
          getLocalAuth = JSON.parse(getLocalAuth);
          if (getLocalAuth.hasOwnProperty("token")) {
            requestPay.headers = {
              Authorization: 'Bearer ' + getLocalAuth.token
            }
          }
        }

        axios(requestPay)
          .then((response) => {
            const {
              isAdmin,
              data,
              isOpenRoom,
              RoomResult,
              isAlreadyPaid,
              isPasswordProtected,
              isPrivate,
              isRoomClaimed,
              room,
              isRoomStarted,
              isPaid,
              paidDetail
            } = response.data;



            let userDetail = {};
            let roomData = {
              room,
              data,
              isRoomClaimed,
              isOpenRoom,
              isAlreadyPaid,
              isPasswordProtected,
              isAdmin,
              isPrivate,
              isRoomStarted,
              user: userDetail,
              isPaid,
              paidDetail
              //...userDetail
            };
            const { dispatch, getLocalParticipant, roomorIpAddress, userLoginData } = this.props;

            // hide pre join meeting screen and connect to conference if room is open/none claimed
            console.log("this.props.userSelectedSkipPrejoin ", this.props.userSelectedSkipPrejoin, getStore("features/prejoin"))
            if ((!room || (room && isAdmin)) && getBaseConfig("showDevicePreJoining") == false) {
              // dispatch(setPrejoinPageVisibility(false, 25));
              _startConference("this open room or im the admin");
              console.log("this open room or im the admin of this room so prejoin screen is hiding")
            }

            let getLocalAuth = localStorage.getItem("auth");
            if (getLocalAuth) {
              getLocalAuth = JSON.parse(getLocalAuth);
              if (getLocalAuth.hasOwnProperty("email") && getLocalAuth.hasOwnProperty("username")) {
                if (isUserLogin) {
                  let abstractData = sessionStorage.getItem("u_detail");
                  let abstractKey = {}
                  try {
                    abstractKey = JSON.parse(abstractData)
                    sessionStorage.removeItem("u_detail")
                  } catch (e) {

                  }
                  userDetail = {
                    ...userLoginData.user,
                    ...abstractKey,
                    email: getLocalAuth?.email,
                    username: getLocalAuth?.username,
                    id: getLocalAuth?.id,
                    type: "room-test"
                  }

                  dispatch(updateSettings({
                    displayName: getLocalAuth.username
                  }))

                  // UPDATE ROOMDATA
                  roomData.user = userDetail;
                  roomData.userName = getLocalAuth.username;
                  roomData.email = getLocalAuth.email;
                }
              }
            }

            if (isPrivate) {
              if (isAdmin) {
                // Will Join
                // roomData.isAdmin = true;
                // roomData.isPrivate = true;
                roomData.isLogged = true;
              } else if (isUserLogin) {
                // Will ask password 
                // roomData.isAdmin = false;
                // roomData.isPrivate = true;
                roomData.isLogged = true;
              } else {
                // Will login
                // roomData.isAdmin = false;
                // roomData.isPrivate = true;
                roomData.isLogged = isUserLogin;
              }
            } else {
              // Can't claim room but user can join
              // roomData.isAdmin = false;
              // roomData.isPrivate = false;
              roomData.isLogged = isUserLogin;
            }

            // let roomUrl = Constant.App.BaseUrl + roomorIpAddress;
            let roomUrl = CURRENT_ROOM_LOCATION;
            let willConnect = false;
            if (!roomData.isLogged && !roomData.isAdmin && roomData.isPrivate) {
              willConnect = false;
            } else if (roomData.isPrivate && roomData.isLogged) {
              if (roomData.isAdmin) {
                if (roomData.isRoomStarted) {
                  socketEmit('moderator_grant', {
                    location: roomUrl,
                    lobby: false,
                    isAdminRight: true,
                    getRoomStatus: true
                  });
                }
                willConnect = true;
                // } else {
                //   willConnect = false;
              }
              // } else if (!roomData.isPrivate ) {
              //   willConnect = true;
            } else if (!roomData.isPrivate && !roomData.isRoomClaimed) {
              willConnect = true;
            } else if (!roomData.isPrivate && roomData.isRoomClaimed /*&& !roomData.isRoomStarted*/ && !roomData.isAdmin && roomData.isLogged) {
              willConnect = true;
            } else if (!roomData.isPrivate && roomData.isRoomClaimed /*&& !roomData.isRoomStarted*/ && roomData.isAdmin && roomData.isLogged) {
              // let newRoom = this.state.roomName;
              // if (ValidateIPaddress(this.state.roomName)) {
              //     newRoom = newRoom.replace(/\./g, '-');
              // }
              socketEmit('moderator_grant', {
                location: roomUrl,
                lobby: false,
                isAdminRight: true,
                getRoomStatus: true
              });
              willConnect = true;
            } else if (!roomData.isPrivate && roomData.isRoomClaimed /*&& !roomData.isRoomStarted && roomData.isLogged*/) {
              //if (isAdmin) {
              willConnect = true;
              // } else {
              //     willConnect = false;
              //}
            }

            if (roomData.isPasswordProtected && !roomData.isAdmin) {
              willConnect = false;
            }

            if (isAlreadyPaid) {
              willConnect = true;
            }

            if (!roomData.isAdmin && roomData?.room?.paid == true && roomData?.isPaid == false) {
              willConnect = false;
            }

            if (!roomData.isAdmin && roomData?.room?.paid == true && roomData?.isPaid == true) {
              if (roomData.isPasswordProtected) {
                willConnect = false;
              } else {
                willConnect = true;
              }
            }

            if (isGhostUser()) {
              sessionStorage.removeItem("isPaid");
              sessionStorage.setItem("isPaid", true);
              roomData.isAdmin = true;
              roomData.isLogged = true;
              willConnect = true;
              _startConference(5);
              return true;
            } else if (window.location.hash.indexOf("config.iAmRecorder") != -1) {
              sessionStorage.removeItem("isPaid");
              sessionStorage.setItem("isPaid", true);
              roomData.isAdmin = true;
              roomData.isLogged = true;
              willConnect = true;
              // socketEmit('moderator_grant', {
              //   location: roomUrl,
              //   lobby: false,
              //   isAdminRight: false,
              //   getRoomStatus: true
              // });
            }

            let isClaimedMusicUser = false;
            let hasMusicRoom = sessionStorage.getItem("claimedUserD");
            if (hasMusicRoom) {
              try {
                let musicUserDetail = JSON.parse(hasMusicRoom);
                if (musicUserDetail.roomName && musicUserDetail.roomLocation && musicUserDetail.time) {
                  if (calculateTimeDiff(musicUserDetail.time, messages.musicModeTimeLimit)) {
                    if (CURRENT_ROOM_LOCATION == musicUserDetail.roomLocation) {
                      willConnect = true;
                      isClaimedMusicUser = true;
                    }
                  }
                }
              } catch (e) {

              }
            }
            let ipAddress = CURRENT_ROOM_NAME
            // event should not send when user is on prejoin screen
            // if (ipAddress && roomData && this.props.conferenceJoined) {
            if (ipAddress && roomData && !isAdmin) {
              let obj = {
                isAdmin: isAdmin,
                name: roomData.userName,
                email: roomData.email,
                roomName: ipAddress,
                socketId: localStorage.getItem('socketId'),
                organization_id: this.props?.authOrganization?._id,
                organization: this.props?.authOrganization?.name,
                // jitsiId: getLocalParticipant.id
              };
              // socketEmit("user_added", obj);
            }
            setCurrentUser(roomData);

            let store_v1 = getStore(FEATURE_CUSTOM_REDUX);
            let prejoinStore = getStore("features/prejoin");
            if (store_v1.userLoginData?.user) {
              roomData.user = {
                ...roomData.user,
                ...store_v1.userLoginData?.user
              }
            }

            // User will join only is, user is admin of room or password entered or room is opened
            dispatch(setUserLoginData(roomData, 7));
            if (ipAddress && willConnect) {
              if (!APP.conference.isJoined()) {
                if (roomData.user.email) {

                }
                if (isClaimedMusicUser) {
                  _startConference(1);
                }

                if ((isRoomClaimed && isAdmin) || !isRoomClaimed) {
                  if (getBaseConfig("showDevicePreJoining") == true) {
                    if (this.props.prejoinScreenUserRoute == InvitedUserConfirmFlag.IS_CONFIRMING || invitedUserConfirm == InvitedUserConfirmFlag.IS_CONFIRMING) {
                    } else {
                      if (!prejoinStore.showPrejoin || this.props.deviceInfoMessages?.info_code == INFO_CODE.ALL_SET) {
                        // _startConference(2);
                      }

                      if (!prejoinStore.showPrejoin) {
                        setTimeout(function () {
                          _startConference("Prejoin is not showing");
                        }, 4000)
                      }
                    }
                  } else {
                    if (!prejoinStore.showPrejoin) {
                      _startConference("no prejoin screen join");
                    } else {
                      if (isAdmin) {
                        _startConference("prejoin is visible and am admin of room ", isAdmin);
                        console.log("prejoin meeting is visible 41", isAdmin)
                      } else {
                        console.log("prejoin meeting is visible 40", isAdmin)
                      }
                    }
                  }
                } else if (!isRoomStarted) {
                  dispatch(hideApiLoader())
                  dispatch(setWaitingScreen(true, 8));
                  dispatch(setWaitingScreenStatus(true));
                  this.setState({ openWaiting: true })
                } else if (isRoomStarted) {
                  if (getBaseConfig("showDevicePreJoining") == true) {
                    if (!userLoginData.user?.id && userLoginData.user?.is_invited == true) {
                    } else {
                      // if (userLoginData.user?.id && userLoginData.user?.is_invited && invitedUserConfirm == InvitedUserConfirmFlag.IS_CONFIRMING) {
                      if (this.props.prejoinScreenUserRoute == InvitedUserConfirmFlag.IS_CONFIRMING || invitedUserConfirm == InvitedUserConfirmFlag.IS_CONFIRMING) {
                      } else {
                        if (!prejoinStore.showPrejoin) {
                          dispatch(setWaitingScreen(false));
                          _startConference(3);
                        } else {
                          if (isWaiting) {
                            dispatch(setWaitingScreen(false));
                          }

                        }
                      }
                    }
                  } else {
                    if (!prejoinStore.showPrejoin) {
                      _startConference("no prejoin screen join two");
                    } else {
                      // no admin
                      // room started
                      // room claimed
                      //  if paid room then should paid
                      // not password protected
                      if (!isAdmin && isRoomStarted && isRoomClaimed && !isPrivate) {
                        if (room?.paid) {
                          if (isPaid) {
                            dispatch(setPrejoinPageVisibility(false, 28));
                            _startConference("i can join conference as i have aleady paid for this room");
                          }
                        } else {
                          dispatch(setPrejoinPageVisibility(false, 29));
                          _startConference("room already started");
                        }
                      }
                      console.log("check base ment ", 5)
                    }
                  }

                  // if(!userLoginData.user?.id && userLoginData.user?.is_invited == true){
                  // }else {
                  //   if(userLoginData.user?.id && userLoginData.user?.is_invited && invitedUserConfirm == InvitedUserConfirmFlag.IS_CONFIRMING){
                  //   }else {
                  //     dispatch(setWaitingScreen(false));
                  //     _startConference(3);
                  //   }
                  // }
                } else {
                  // dispatch(setWaitingScreen(false));
                  // _startConference(4);
                }
              }
            } else {
              // dispatch(setUserLoginData(roomData,8));
              if (roomData.isPasswordProtected) {
                // by pass guest user 
                if (store_v1.userLoginData?.user?.id && store_v1.userLoginData?.user.is_invited == true) {
                  dispatch(setRoomPassProtect(false));
                } else {
                  dispatch(setRoomPassProtect(true));
                }
              }

              dispatch(setPaidRoomDetail({
                passwordProtected: roomData.isPasswordProtected,
                isRoomPaid: roomData?.room?.paid || false,
                time: Math.round(new Date().getTime() / 1000),
                isUserMadePayment: false,
                isRoomStarted: response.data.isRoomStarted
              }))
            }

            this.setState({
              roomStatusStamp: Math.round(new Date().getTime() / 100)
            })

          }).catch(error => {
            console.log("session API error =>", error);
          });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      isUserLogin,
      setCurrentUser,
      _iAmRecorder,
      isWaiting,
      isOnline,
      authOrganization,
      getLocalParticipant,
      userLoginData,
      userMakeRoomPayment,
      isWaitingScreen
    } = this.props;

    const {
      email,
      userName,
      isAdmin,
      isRoomClaimed,
      room
    } = userLoginData;


    if (prevProps.isUserLogin != isUserLogin) {
      const { systemIp, localIp } = this.state;
      //CUSTOM
      // if (localIp && systemIp) {
      let t_this = this;
      setTimeout(function () {
        t_this.getRoomStatus(2, isUserLogin)
      }, 3000)
      // }
    }

    if (prevProps.deviceInfoMessages?.show != this.props.deviceInfoMessages?.show || prevProps.deviceInfoMessages?.info_code != this.props.deviceInfoMessages?.info_code) {
      if (this.props.deviceInfoMessages?.show) {
        if (this.props.deviceInfoMessages?.info_code == INFO_CODE.ALL_SET) {
          this.getRoomStatus(3)
        }
        // user complete prejoining screen
      }
    }

    if (prevProps.invitedUserConfirm != this.props.invitedUserConfirm) {
      if (this.props.invitedUserConfirm == InvitedUserConfirmFlag.WITHOUT_DEVICE_U_LOGIN) {
        // user is login want to go without device
        this.getRoomStatus(4)
      }
    }

    if (prevProps.userMakeRoomPayment != userMakeRoomPayment) {
      this.getRoomStatus(5)
    }

    if (prevProps.isOnline != isOnline) {
      // if (isRoomClaimed && isOnline && this.props.conferenceJoined) {
      if (isRoomClaimed && isOnline) {
        let userPosition = {
          basicInfo: {}
        }

        setTimeout(async () => {
          let resp = await getUserLocation();
          userPosition.basicInfo = resp.basicInfo;

          let obj = {
            userId: userLoginData?.user?.id,
            isAdmin: isAdmin,
            name: userName,
            email: email,
            roomName: CURRENT_ROOM_NAME,
            socketId: localStorage.getItem('socketId'),
            organization_id: authOrganization?._id,
            organization: authOrganization?.name,
            jitsiId: getLocalParticipant.id,
            ...userPosition.basicInfo
          };
          socketEmit("user_added", obj);
        })
      }
    }

    let { roomStatusStamp, openWaiting } = this.state;
    // send user_added event when actual waiting screen is showing
    if (prevState.roomStatusStamp != roomStatusStamp) {
      if (isWaiting || isWaitingScreen) {
        // check if user is waiting to for room owner
        console.log("check if user is waiting to for room owner", isWaiting, isWaitingScreen)
        this.waitingInterval()
      }

      if (isWaiting && openWaiting) {
        let waitingModal = document.querySelectorAll(["div[data-testid=waitingScreen-dialog-content]"]);
        if (waitingModal.length) {
          if (waitingModal[0]) {
            // reminder email to room owner (code start from here)
            const { email: roomOwnerEmail, groupName, userName: roomOwnerName, isAdminSubscribed, phone = "" } = room;
            let time = Math.round(new Date().getTime() / 1000);
            let isOwnerReminder = localStorage.getItem('isOwnerReminder-' + CURRENT_ROOM_NAME);
            let payload = {
              email: roomOwnerEmail,
              url: getBaseConfig("socialReferrerUrl") + "/" + groupName,
              userName: roomOwnerName,
              isAdminSubscribed: isAdminSubscribed ? true : false,
              phone
            }

            if (getBaseConfig("roomOwnerReminderEmail")) {
              if (!isOwnerReminder) {
                reminderEmailToRoomOwner(payload);
                localStorage.setItem('isOwnerReminder-' + CURRENT_ROOM_NAME, time)
              } else if (isOwnerReminder && !calculateTimeDiff(isOwnerReminder, 120)) {
                reminderEmailToRoomOwner(payload)
                localStorage.setItem('isOwnerReminder-' + CURRENT_ROOM_NAME, time)
              }
            }
            // end here

            let userPosition = {
              basicInfo: {}
            }

            setTimeout(async () => {
              let resp = await getUserLocation();
              userPosition.basicInfo = resp.basicInfo;

              let participantPay = {
                userId: userLoginData?.user?.id,
                isAdmin: isAdmin,
                name: userName,
                email: email,
                roomName: CURRENT_ROOM_NAME,
                socketId: localStorage.getItem('socketId'),
                organization_id: authOrganization?._id,
                organization: authOrganization?.name,
                jitsiId: getLocalParticipant.id,
                ...userPosition.basicInfo
              };

              socketEmit("user_added", participantPay);
            })
          }
        }
      }
    }
  }

  waitingInterval = () => {
    let _this = this;
    console.log("Interval request ")
    if(this.state.isWaitingInterval){
     return false;
    }

    this.setState({
      isWaitingInterval : true
    })

    // to check room status after every 10 sec
    let inter = setInterval(async function () {
      let {
        conferenceJoined
      } = _this.props;
      console.log("tim now ",new Date())

      console.log("checking room status ", "conferenceJoined", conferenceJoined);
      if (!conferenceJoined) {
        let roomData = await getRoomDetail(CURRENT_ROOM_NAME);
        console.log("roomDataroomData ",roomData)
        if (roomData.status == 1) {
          if (roomData.data.isRoomStarted) {
            dispatch(setWaitingScreen(false));
            dispatch(setWaitingScreenStatus(false));
            _startConference(19);
            clearInterval(inter)
            _this.setState({
              isWaitingInterval : false
            })
            console.log("I will start conference as room is started now")
          }
        }
      } else {
        console.log("seems conference is joined so interval is cleared")
        clearInterval(inter)
        _this.setState({
          isWaitingInterval : false
        })
      }
    }, 10000)
  }

  login = () => {
    const { login: { username, password }, browserSession, systemIp, localIp } = this.state;
    const { dispatch, authOrganization, toolModal } = this.props;
    const config = {
      headers: {
        'content-type': 'application/json'
      }
    };

    this.setState({
      isLoading: true,
    });


    userLogin({
      email: username,
      password,
      ip: localIp,
      systemIp: systemIp,
      browser: browserSession,
      remember: true,
      organization_id: authOrganization?._id
    }).then(async (res) => {
      if (res.status == 1) {

        this.setState({
          login: {
            username: '',
            password: ''
          }
        })

        if (toolModal.componentName) {
          dispatch(openDialog(StartRecordingDialog));
          setTimeout(function () {
            dispatch(setToolModal({
              toolName: "",
              toolType: "",
              componentName: ""
            }))
          }, 3000)
        }

        if (res.data) {
          let saveData = res.data;

          let saveSession = {}

          if (saveData.hasOwnProperty("stripe_account_id")) {
            if (saveData.stripe_account_id != "" || saveData.stripe_account_id == true) {
              saveSession.stripe_account_id = "true";

              if (saveData.connectVerified != undefined) {
                saveSession.connectVerified = saveData.connectVerified;
              }
            }
          }

          if (saveData.hasOwnProperty("stripe_customer_id")) {
            if (saveData.stripe_customer_id != "" || saveData.stripe_customer_id == true) {
              saveSession.stripe_customer_id = "true";
            }
          }

          const {
            userLoginData
          } = this.props;

          dispatch(setUserLoginData({
            ...userLoginData,
            user: {
              ...userLoginData.user,
              ...saveSession
            }
          }, 9))

          localStorage.setItem("auth", JSON.stringify({
            email: saveData.email,
            id: saveData.id,
            refreshToken: saveData.refreshToken,
            token: saveData.token,
            username: saveData.username
          }));


          Toast(ct("messages.loginSuccess", "messages"), Constant.App.ToastTime.LongCloseTime);
          dispatch(setUserIsLogin(true));
          this.props.closeLogin(false)


          sendAnalytics({
            action: 'sign-in',
            source: "toolbar",
            category: "login"
          });
          this.setState({
            openSignIn: false,
          });
        } else {
          if (res.data != '') {
            let msg = await dynamicMessageLocale(res.data.message);
            Toast(msg, Constant.App.ToastTime.LongCloseTime)
          } else if (res.message != '') {
            let msg = await dynamicMessageLocale(res.message);
            Toast(msg, Constant.App.ToastTime.LongCloseTime)
          }
        }
      } else {
        if (res.data != '') {
          let msg = await dynamicMessageLocale(res.data.message);
          Toast(msg, Constant.App.ToastTime.LongCloseTime)
        } else if (res.message != '') {
          let msg = await dynamicMessageLocale(res.message);
          Toast(msg, Constant.App.ToastTime.LongCloseTime)
        }
      }
    }).finally(() => {
      this.setState({
        isLoading: false,
      });

    });
  }

  changeField = ({ target: { value, name } }) => {
    this.setState({
      login: {
        ...this.state.login,
        [name]: value
      }
    });
  }

  changeRegField = ({ target: { value, name } }) => {
    this.setState({
      register: {
        ...this.state.register,
        [name]: value
      }
    });
  }

  changeForgotField = ({ target: { value, name } }) => {
    this.setState({
      forgotpass: {
        ...this.state.forgotpass,
        [name]: value
      }
    });
  }

  signUpDialog = () => {
    const { closeLogin, isClaimClicked } = this.props;
    closeLogin(false, isClaimClicked);

    this.setState({
      isSignUpOpen: true,
      isForgetPass: false,
      openSignUp: true,
      openSignIn: false,
    });
  }

  forgorPassDialog = () => {
    const { closeLogin, isClaimClicked } = this.props;

    closeLogin(false, isClaimClicked);

    this.setState({
      isSignUpOpen: false,
      isForgetPass: true,
      openForgotPass: true,
      openSignIn: false,
    });
  }

  loginClose = () => {
    const { closeLogin } = this.props;
    const { notSignIn } = this.state;

    closeLogin(false);
    this.setState({
      openSignIn: false
    });
    if (notSignIn) {
      this.setState({ openSignIn: false, notSignIn: false })
      window.location.href = window.location.origin;
    }

    let obj = {
      toolName: "",
      toolType: "",
      componentName: ""
    }
    this.props.dispatch(setToolModal(obj))
  }

  maskEye = (type) => {
    let passInput = document.getElementById("login-password-input")
    if (passInput) {
      if (type) {
        passInput.setAttribute("type", "password")
      } else {
        passInput.setAttribute("type", "text")
      }
    }

    this.setState({
      isMaskEye: type
    });
  }

  signInModel = () => {
    const { closeLogin, roomPassProtectModal, _iAmRecorder, userLoginData } = this.props;
    const { login: { username, password }, isLoading, isMaskEye } = this.state;

    if (isGhostUser()) {
      return null;
    }

    if (userLoginData.user.id && userLoginData.user.is_invited == true) {
      closeLogin(false)
      return null;
    }

    return (
      <ModalDialog
        heading={ct('rta-trmc.avatar.signIn')}
        testId={"login-modal"}
        components={{
          Footer: () => <Footer
            // isLoading={isLoading}
            className={isLoading ? "login-modal-loading" : ""}
            text={ct('rta-trmc.avatar.signIn')}
            onSubmit={() => this.login()}
            onClose={() => this.loginClose()}
            showKeyline={false}
            roomPassProtectModal={roomPassProtectModal}
          />,
          Container: 'div',
        }}
      >
        <input
          autoComplete='off'
          name="username"
          type="text"
          value={username}
          className="input-control"
          onChange={this.changeField}
          placeholder={ct('rta-trmc.avatar.enterEmail')}
          autoFocus /> <br />
        <div className="pass-outer">
          <input
            type="password"
            name="password"
            id="login-password-input"
            value={password}
            className="input-control"
            onChange={this.changeField}
            placeholder={ct('rta-trmc.avatar.enterPassword')} />
          {isMaskEye ?
            <>
              <i className="fa fa-eye icon-after"
                onClick={() =>
                  this.maskEye(false)}
              ></i>
            </> : <>
              <i className="fa fa-eye-slash icon-after"
                onClick={() =>
                  this.maskEye(true)}
              ></i>
            </>
          }
        </div>
        <br />
        <span className="sign-up-content" onClick={this.signUpDialog}>{ct('rta-trmc.avatar.signUp')}</span>
        <span className="forgot-password" onClick={this.forgorPassDialog}>{ct('rta-trmc.avatar.forgotPassword')}</span>
      </ModalDialog>
    );
  }

  register = () => {

    const { register: { username, password, email }, browserSession, systemIp, localIp } = this.state;
    const config = {
      headers: {
        'content-type': 'application/json'
      }
    };

    if (!email) {
      Toast(ct("messages.emailRequired", "messages"), Constant.App.ToastTime.LongCloseTime);
      return false;
    } else if (!ValidateEmail(email)) {
      Toast(ct("messages.emailInvalid", "messages"), Constant.App.ToastTime.LongCloseTime);
      return false;
    } else if (!username) {
      Toast(ct("messages.usernameRequired", "messages"), Constant.App.ToastTime.LongCloseTime);
      return false;
    } else if (username?.length < 3) {
      Toast(ct("messages.usernameLen", "messages"), Constant.App.ToastTime.LongCloseTime);
      return false;
    } else if (!ValidateUsername(username)) {
      Toast(ct("messages.usernameInvalid", "messages"), Constant.App.ToastTime.LongCloseTime);
      return false;
    } else if (!password) {
      Toast(ct("messages.passwordRequired", "messages"), Constant.App.ToastTime.LongCloseTime);
      return false;
    } else if (password?.length < 6) {
      Toast(ct("messages.passwordLen", "messages"), Constant.App.ToastTime.LongCloseTime);
      return false;
    } else if (!ValidatePassword(password)) {
      Toast(ct("messages.passwordInvalid", "messages"), Constant.App.ToastTime.LongCloseTime);
      return false;
    }
    this.setState({
      isLoading: true,
    });
    const { dispatch, authOrganization, toolModal } = this.props;

    userSignup({
      username,
      email,
      password,
      ip: localIp,
      systemIp: systemIp,
      browser: browserSession,
      organization_id: authOrganization?._id,
    }).then(async (res) => {
      if (res.status == 1) {

        if (toolModal.componentName) {

          setTimeout(function () {

            dispatch(openDialog(StartRecordingDialog));
            dispatch(setToolModal({
              toolName: "",
              toolType: "",
              componentName: ""
            }))
          }, 3000)
        }

        if (res.data) {

          const {
            userLoginData
          } = this.props;

          dispatch(setUserLoginData({
            ...userLoginData,
            user: {
              ...userLoginData.user,
              ...res.data
            },
          }, 10))

          localStorage.setItem("auth", JSON.stringify(res.data));
          dispatch(setUserIsLogin(true));
          this.setState({
            isSignUpOpen: false,
            openSignIn: false
          })
          this.props.closeLogin(false)

          this.setState({
            register: {
              username: '',
              password: '',
              email: ''
            }
          })
          Toast(ct("messages.signupSuccess", "messages"), Constant.App.ToastTime.LongCloseTime);
          sendAnalytics({
            action: 'sign-up',
            source: "toolbar",
            category: "register"
          });
        } else {
          if (res.data != '') {
            let msg = await dynamicMessageLocale(res.data.message);
            Toast(msg, Constant.App.ToastTime.LongCloseTime)
          }
        }
      } else {
        if (res.data != '') {
          let msg = await dynamicMessageLocale(res.data.message);
          Toast(msg, Constant.App.ToastTime.LongCloseTime)
        }
      }
    }).catch(e => {
    })
      .finally(e => {
        this.setState({
          isLoading: false,
        });
      })
  }

  sendMail = () => {
    const { forgotpass: { email } } = this.state;
    const { authOrganization } = this.props

    if (ValidateEmail(email)) {
      const config = {
        headers: {
          'content-type': 'application/json'
        }
      };

      this.setState({
        isLoading: true,
      });

      axios.post(`${socket_endpoint + (getBaseConfig("apiVersion") || apiVersion)}/send_reset_link`, {
        email,
        organization_id: authOrganization?._id
      }, config).then(async (response) => {
        this.setState({
          isLoading: false,
        });

        if (response.data.status) {
          //alert(response.data.message);
          let msg = await dynamicMessageLocale(response.data.message);
          Toast(msg, Constant.App.ToastTime.LongCloseTime);
          this.setState({
            forgotpass: {
              email: ''
            }
          })
          this.regLoginOpen();
          sendAnalytics({
            action: 'forgot-password',
            source: "toolbar",
            category: "forgot password"
          });
        } else {
          let msg = await dynamicMessageLocale(response.data.message);
          Toast(msg, Constant.App.ToastTime.LongCloseTime)
        }
      }).catch(error => {
        Toast(ct("messages.contactAdmin", "messages"), Constant.App.ToastTime.LongCloseTime);
      });
    } else {
      Toast(ct("messages.invalidEmail", "messages"), Constant.App.ToastTime.LongCloseTime);
    }
  }

  regLoginOpen = () => {
    const { closeLogin, isClaimClicked } = this.props;
    // open the login popup
    closeLogin(true, isClaimClicked);

    this.setState({
      isSignUpOpen: false,
      isForgetPass: false,
    });

  }

  closeSignUp = () => {
    const { roomPassProtectModal, closeLogin, isClaimClicked } = this.props;

    this.setState({
      isSignUpOpen: false
    });
    closeLogin(false, isClaimClicked, "sign-up")

    if (roomPassProtectModal) {
      this.regLoginOpen();
    } else {
      this.setState({
        isForgetPass: false,
      });
    }

    let obj = {
      toolName: "",
      toolType: "",
      componentName: ""
    }
    this.props.dispatch(setToolModal(obj))

    // window.location.reload();
  }

  signUpModel = () => {
    const { isLoading, register: { email, username, password }, isMaskEye } = this.state;

    return (
      <ModalDialog heading="Sign Up"
        testId={"signup-modal"}
        components={{
          Footer: () => <Footer
            // isLoading={isLoading}
            className={isLoading ? "signup-modal-loading" : ""}
            text="Sign Up"
            onSubmit={() => this.register()}
            onClose={() => this.closeSignUp()}
            showKeyline={false} />,
          Container: 'div',
        }}
      >
        <label>{ct("rta-trmc.dialogs.email")}:</label>
        <input
          autoComplete='off'
          name="email"
          type="text"
          value={email}
          // className="input-control"
          className="input-control theme-input-focus"
          onChange={this.changeRegField}
          placeholder={ct("rta-trmc.avatar.enterEmail")} autoFocus /> <br />
        <label>{ct("rta-trmc.dialogs.userName")}:</label>
        <input
          autoComplete='off'
          name="username"
          type="text"
          value={username}
          // className="input-control"
          className="input-control theme-input-focus"
          onChange={this.changeRegField}
          placeholder={ct("rta-trmc.avatar.enterUserName")}
        /> <br />
        <label>{ct("rta-trmc.avatar.personalPassword")}:</label>
        <div className="pass-outer">
          <input
            name="password"
            type="password"
            id="login-password-input"
            value={password}
            // className="input-control"
            className="input-control theme-input-focus"
            onChange={this.changeRegField}
            placeholder={ct("rta-trmc.avatar.enterPassword")} />
          {isMaskEye ?
            <>
              <i className="fa fa-eye icon-after"
                onClick={() =>
                  this.maskEye(false)}
              ></i>
            </> : <>
              <i className="fa fa-eye-slash icon-after"
                onClick={() =>
                  this.maskEye(true)}
              ></i>
            </>
          }
        </div>
        <br />
        <span className="forgot-password" onClick={() => {
          this.setState({
            isSignUpOpen: false,
            openSignIn: true
          })
          // this.regLoginOpen()

        }} >{ct("rta-trmc.avatar.signIn")}</span>
      </ModalDialog>
    );
  }

  forgotPass = () => {
    const { forgotpass: { email }, isLoading } = this.state;

    return (
      <ModalDialog heading="Forgot Password"
        components={{
          Footer: () => <Footer
            isLoading={isLoading}
            text="Send Mail"
            onSubmit={() => this.sendMail()}
            //onClose={() => this.setState({ isForgetPass: false })}
            onClose={() => this.closeSignUp()}
            showKeyline={false} />,
          Container: 'div',
        }}
      >
        <label>{ct("rta-trmc.dialogs.email")}:</label>
        <input
          autoComplete='off'
          name="email"
          type="text"
          value={email}
          // className="input-control"
          className="input-control theme-input-focus"
          onChange={this.changeForgotField}
          placeholder={ct("rta-trmc.avatar.enterEmail")} autoFocus /> <br />
        <span className="forgot-password" onClick={this.regLoginOpen}>{ct("rta-trmc.avatar.signIn")}</span>
      </ModalDialog>
    );
  }

  waitingModel = () => {
    const { isUserLogin, conferenceJoined } = this.props

    // let canShow = canUserJoinMeeting();
    // if (!canShow) {
    //   return null;
    // }

    if (conferenceJoined) {
      return null;
    }
    const isGuestUser = getLJsonStorage("auth", "guest_id");

    return (
      <>
        {isUserLogin ?
          <Dialog
            disableAutoHideOnSubmit={true}
            disableBackdropClose={true}
            hideCloseButton={true}
            cancel={{ hidden: true }}
            ok={{ hidden: true }}
            titleKey={ct("rta-trmc.waitingDialog.title")}
            rtaClassName="upload-modal-wrapper"
            testId='waitingScreen'
            zIndex={99999}
          >
            {/* // <ModalDialog heading="Waiting Screen"
          //   testId='waitingScreen'
          //   stackIndex={10}
          //   components={{
          //     Footer: () => <Footer
          //       className={"hide-footer"}
          //       isLoading={false}
          //       showKeyline={false} />,
          //     Container: 'div',
          //   }}
          // > */}
            <div className='waiting text-center waiting-login-container' id='lobby-screen'>
              {<span className="newDIv close waiting">
                <img src={cross} onClick={
                  (e) => {
                    e.preventDefault();
                    // if (getBaseConfig("hidePreJoinScreen")) {
                      if (isSocialMobileApp()) {
                        window.parent.location.href = getBaseConfig("appReferrerUrl");
                      } else {
                        // social url change code
                        let socialAllowed = getBaseConfig("socialAllowed");
                        if (socialAllowed == true) {
                          let socialReferrerUrl = getBaseConfig("socialReferrerUrl");
                          let refreshUrl = socialReferrerUrl + "/OuIVuX07";
                          window.parent.location.href = refreshUrl;
                        } else {
                          window.location.href = "/"
                        }
                      }
                    // } else {
                    //   dispatch(setWaitingScreenStatus(false));
                    // }

                    // window.location.href = "/";
                    // if (isSocialMobileApp()) {
                    //   window.parent.location.href = getBaseConfig("appReferrerUrl");
                    // } else {
                    //   // social url change code
                    //   let socialAllowed = getBaseConfig("socialAllowed");
                    //   if (socialAllowed == true) {
                    //     let socialReferrerUrl = getBaseConfig("socialReferrerUrl");
                    //     let refreshUrl = socialReferrerUrl + "/OuIVuX07";
                    //     window.parent.location.href = refreshUrl;
                    //   } else {
                    //     window.location.href = "/"
                    //   }
                    // }
                  }
                } />
              </span>}
              <div className="waiting-room-inner">
                {isGuestUser ? <p>
                  {ct("rta-trmc.waitingDialog.waitingMsg")} <br /> <span>{ct("rta-trmc.waitingDialog.roomOwner")} <span onClick={() => {
                    window.parent.location.href = Constant.App.socialUrl
                  }} id="sign-in-link" className="hyperlink-text coupon-code-link"> {ct("rta-trmc.avatar.signIn")}.</span></span>
                </p>
                  :
                  <p>
                    {ct("rta-trmc.waitingDialog.waitingMsg")}...
                  </p>
                }
              </div>
            </div>
            {/* </ModalDialog> */}
          </Dialog>
          :
          <ModalDialog heading={ct("rta-trmc.waitingDialog.title")}
            components={{
              Footer: () => <Footer
                className={"hide-cancel"}
                // onClose={() => this.loginClose()}
                text={ct("rta-trmc.avatar.signIn")}
                onSubmit={() => this.setState({ openSignIn: true })}
                isLoading={false}
                showKeyline={false} />,
              Container: 'div',
            }}
          >

            <div className='waiting text-center waiting-login-container' id='lobby-screen'>
              <span className="newDIv close waiting">
                <img src={cross} onClick={
                  (e) => {
                    e.preventDefault();
                    window.location.href = "/";
                  }
                } />
              </span>
              <div className="waiting-room-inner">
                <p>
                  {ct("rta-trmc.waitingDialog.waitingMsg")} <br /> <span>{ct("rta-trmc.waitingDialog.roomOwner")} {ct("rta-trmc.avatar.signIn")}.</span>
                </p>
              </div>
            </div>
          </ModalDialog>
        }
      </>
    );
  }

  currentDialog = () => {
    const { isForgetPass, isSignUpOpen, openSignIn, openSignUp, openForgotPass, openWaiting } = this.state;
    const {
      isOpen,
      isWaiting,
      toolModal,
      isInvitedUserMState,
      userLoginData,
      isJammingCapability,
      invitedUserConfirm,
      prejoinScreenUserRoute,
      alwaysShowPreJoining,
      isWaitingScreen,
      userPrejoinAllSet,
      conferenceJoined
    } = this.props;
    let getLocalAuth = localStorage.getItem("auth");
    if (localStorage.getItem("auth")) {
      getLocalAuth = JSON.parse(getLocalAuth);
    }

    if (invitedUserConfirm == InvitedUserConfirmFlag.IS_CONFIRMING && !getBaseConfig("showPreJoiningInConference")) {
      return <JammingCapabilityModal />
    } else if (
      invitedUserConfirm == InvitedUserConfirmFlag.IS_CONFIRMING &&
      getBaseConfig("noDevicePreJoiningScreen") &&
      !userPrejoinAllSet && userLoginData?.room
    ) {

      const hidePreJoinScreen = getBaseConfig("hidePreJoinScreen");
      if (hidePreJoinScreen && userLoginData?.room?.admin) {
        dispatch(setPrejoinPageVisibility(false, 18));
      } else {
        dispatch(setPrejoinPageVisibility(true, 19));
      }

    }

    if (prejoinScreenUserRoute == InvitedUserConfirmFlag.IS_CONFIRMING && alwaysShowPreJoining && !getBaseConfig("showPreJoiningInConference")) {
      return <PrejoinScreenUserRoute />
    } else if (
      prejoinScreenUserRoute == InvitedUserConfirmFlag.IS_CONFIRMING &&
      alwaysShowPreJoining &&
      getBaseConfig("noDevicePreJoiningScreen") &&
      !userPrejoinAllSet
    ) {
      // if ((!conferenceJoined && userLoginData?.room?._id) || userLoginData?.isOpenRoom) {
      //   const _hidePreJoinScreen = getBaseConfig("hidePreJoinScreen");
      //   if (_hidePreJoinScreen && userLoginData?.room?.admin) {
      //     dispatch(setPrejoinPageVisibility(false, 20));
      //   } else {
      //     // dispatch(setPrejoinPageVisibility(true, 21));
      //   }
      // }
    }

    if (isInvitedUserMState) {
      return <InviteRegisterModal />;
    }


    let canShow = canUserJoinMeeting();
    let canShowPrejoin = getStore('features/prejoin')?.showPrejoin;
    if (!canShowPrejoin && !canShow) {
      let current_room_jamming_capability = getLJsonStorage("auth", "current_room_jamming_capability") || {}
      if (Object.keys(current_room_jamming_capability).length && current_room_jamming_capability?.status != 1) {
        canShow = true;
      }
    }

    if (!canShow) {
      if (userLoginData.user?.id && userLoginData.user?.is_invited == true) {
        if (this.props.showPrejoin) {
          if (this.props.deviceInfoMessages?.info_code == INFO_CODE.ALL_SET) {

          } else {
            return null
          }
        }
      } else {
        let withoutJam = getLJsonStorage("auth", "without_jamming");
        if (withoutJam) {
        } else {
          return null;
        }
      }
    }

    if (isOpen && !openSignIn) {
      if (toolModal.toolName == "login") {
      } else if (toolModal.toolName == "signup") {
        return this.signUpModel()
      }
      else {
        return this.signInModel()
      }
    } else {
      if (isOpen || openSignIn) {
        return this.signInModel()
      } else if (isSignUpOpen || (isSignUpOpen && openSignUp)) {
        return this.signUpModel()
      } else if (isForgetPass || (isForgetPass && openForgotPass)) {
        return this.forgotPass()
      } else if ((isWaiting || isWaitingScreen) && !userLoginData?.isAdmin && userLoginData?.room) {
        return this.waitingModel()
      } else {
        return <></>

      }
    }

    // if (isOpen || (toolModal.toolName == "login" && isOpen) || openSignIn) { return this.signInModel() }
    // else if ((isOpen && toolModal.toolName == "signup") || isSignUpOpen || (isSignUpOpen && openSignUp)) { return this.signUpModel() }
    // else if (isForgetPass || (isForgetPass && openForgotPass)) { return this.forgotPass() }
    // else if (isWaiting && openWaiting) { return this.waitingModel() }
  }

  // render method
  render() {
    return (
      <AtlasKitThemeProvider mode='dark'>
        <ModalTransition>
          {this.currentDialog()}
        </ModalTransition>
      </AtlasKitThemeProvider>
    );
  }
}


function mapStateToProps(state) {

  return {
    isUserLogin: state[FEATURE_CUSTOM_REDUX].isUserLogin,
    userLoginData: state[FEATURE_CUSTOM_REDUX].userLoginData,
    roomPassProtectModal: state[FEATURE_CUSTOM_REDUX].roomPassProtectModal,
    getLocalParticipant: getLocalParticipant(state),
    roomorIpAddress: state[FEATURE_CUSTOM_REDUX].roomorIpAddress,
    isWaiting: state[FEATURE_CUSTOM_REDUX].isWaiting,
    isWaitingScreen: state[FEATURE_CUSTOM_REDUX].isWaitingScreen,
    authVerifyToken: state[FEATURE_CUSTOM_REDUX].authVerifyToken,
    _iAmRecorder: state['features/base/config'].iAmRecorder,
    authOrganization: state[FEATURE_CUSTOM_REDUX_V2].authOrganization,
    isClaimClicked: state[FEATURE_CUSTOM_REDUX].isClaimClicked,
    isOnline: state["features/base/net-info"].isOnline,
    toolModal: state[FEATURE_CUSTOM_REDUX_V2].toolModal,
    conferenceJoined: state[FEATURE_CUSTOM_REDUX].conferenceJoined,
    deviceInfoMessages: state[FEATURE_CUSTOM_REDUX_V2].deviceInfoMessages,
    isInvitedUserMState: state[FEATURE_CUSTOM_REDUX_V3].isInvitedUserMState,
    isJammingCapability: state[FEATURE_CUSTOM_REDUX_V3].isJammingCapability,
    invitedUserConfirm: state[FEATURE_CUSTOM_REDUX_V3].invitedUserConfirm,
    prejoinScreenUserRoute: state[FEATURE_CUSTOM_REDUX_V3].prejoinScreenUserRoute,
    userMakeRoomPayment: state[FEATURE_CUSTOM_REDUX_V3].userMakeRoomPayment,
    showPrejoin: state["features/prejoin"].showPrejoin,
    alwaysShowPreJoining: state[FEATURE_CUSTOM_REDUX_V3].alwaysShowPreJoining,
    userPrejoinAllSet: state[FEATURE_CUSTOM_REDUX_V3].userPrejoinAllSet,
    userSelectedSkipPrejoin: state['features/base/settings'].userSelectedSkipPrejoin
  }
}

export default connect(mapStateToProps)(Login);
